<div class="flex flex-col px-4 py-5">
    <form
        class="mb-10 flex flex-col"
        [formGroup]="form">
        <mat-form-field>
            <mat-label>Id</mat-label>
            <input
                matInput
                formControlName="achievementId" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Title</mat-label>
            <input
                matInput
                formControlName="title" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Achievement type</mat-label>
            <mat-select formControlName="achievementType">
                @for (item of AchievementType | appEnumKeyValue; track $index) {
                    <mat-option [value]="item.value">{{ item.key }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Order</mat-label>
            <input
                matInput
                type="number"
                noScroll
                formControlName="order" />
        </mat-form-field>
        <mat-accordion class="mb-3">
            <mat-expansion-panel
                formArrayName="tiers"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>Tiers</mat-panel-title>
                </mat-expansion-panel-header>
                <button
                    type="button"
                    class="mb-6 self-start"
                    mat-flat-button
                    color="primary"
                    (click)="addTier(null)">
                    Add tier
                </button>
                @for (tier of form.controls.tiers.value; track $index) {
                    <div
                        class="flex flex-col"
                        [formGroupName]="$index">
                        <div class="flex gap-x-4">
                            <img
                                class="size-16"
                                [ngClass]="{ hidden: !tier.logoUrl }"
                                [src]="tier.logoUrl"
                                alt="" />
                            <mat-form-field>
                                <mat-label>Tier</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    noScroll
                                    formControlName="tier" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Description</mat-label>
                                <input
                                    matInput
                                    formControlName="description" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Logo url</mat-label>
                                <input
                                    matInput
                                    formControlName="logoUrl" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Requirement</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    noScroll
                                    formControlName="amount" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Cash reward</mat-label>
                                <input
                                    matInput
                                    type="number"                                    
                                    noScroll
                                    formControlName="reward" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Exp reward</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    noScroll
                                    formControlName="expReward" />
                            </mat-form-field>
                            <button
                                type="button"
                                mat-icon-button
                                (click)="removeTier(tier.tier!)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </mat-expansion-panel>
        </mat-accordion>
        <mat-checkbox
            color="primary"
            formControlName="isActive">
            Active
        </mat-checkbox>
    </form>
    <button
        class="self-start"
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="createOrUpdateAchievement()">
        Save changes
    </button>
</div>
